export default __webpack_public_path__ + "static/media/blog-image1.76408395.png";